module.exports = __webpack_public_path__ + "static/collins-collins-17a11a21fd42f7161c03f91c883b0c01.jpg";